import { useProductTranslations } from "../../hooks/TranslationHooks";
import { useSettings } from "../../hooks/SettingsHooks";
import classNames from "classnames";
import PropTypes from "prop-types";

const FormattedPrice = function FormattedPrice({
  price: _price,
  price_unit,
  sales_unit,
  price_class_name,
  price_unit_class_name,
  bold_price = false,
  currency: _currency
}) {
  const tp = useProductTranslations();
  const settings = useSettings();
  let price = _price;
  if (typeof _price === "string") {
    price = parseFloat(price);
  }
  if (typeof price !== "number") {
    return <></>;
  }
  const currency = _currency || settings.currency;
  // TODO more dynamic currencyLocale
  const currencyLocale = currency === "EUR" ? "de" : "sv";
  const priceComponent = (
    <span
      className={classNames({ "text-bold": !!bold_price }, price_class_name)}
    >
      {price
        .toLocaleString(currencyLocale, {
          style: "currency",
          currency
        })
        .replace(/\D00\b/, "")}
    </span>
  );
  let priceUnitComponent = null;
  if (price_unit) {
    priceUnitComponent = " /" + tp("price_unit." + price_unit);
  }
  if (sales_unit) {
    priceUnitComponent = " /" + tp("sales_unit." + sales_unit);
  }
  if (price_unit_class_name && priceUnitComponent) {
    priceUnitComponent = (
      <span className={price_unit_class_name}>{priceUnitComponent}</span>
    );
  }
  return (
    <>
      {priceComponent}
      {priceUnitComponent}
    </>
  );
};

FormattedPrice.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  price_unit: PropTypes.string,
  sales_unit: PropTypes.string,
  price_class_name: PropTypes.string,
  price_unit_class_name: PropTypes.string,
  bold_price: PropTypes.bool,
  currency: PropTypes.string
};

export default FormattedPrice;
